import { lowerCaseLocale } from "../helper"

const PRISMIC_S3_ENDPOINT = (process.env.PRISMIC_S3_ENDPOINT || "").replace(/\/$/, "")

const fetchS3 = async (url: string) => {
    const response = await fetch(url)
    if (response.ok) return response.clone().json()
    const text = await response.clone().text()
    throw new Error(text || response.statusText)
}

export const fetchS3ContentPage = async <T>(type: "marketing_content" | "service_page", uid: string): Promise<T> =>
    fetchS3(`${PRISMIC_S3_ENDPOINT}/cache/${type}__${uid}__${lowerCaseLocale()}.json`)

export const fetchS3CategoryPage = async <T>(type: "shop_the_look" | "lister" | "category", id: string): Promise<T> =>
    fetchS3(`${PRISMIC_S3_ENDPOINT}/cache/${type}__${id}.json`)

export const fetchS3HomePage = async <T>(): Promise<T> =>
    fetchS3(`${PRISMIC_S3_ENDPOINT}/cache/homepage__${lowerCaseLocale()}.json`)

export const fetchS3PromoTag = async <T>(): Promise<T> =>
    await fetchS3(`${PRISMIC_S3_ENDPOINT}/cache/promo_tag__${lowerCaseLocale()}.json`)

export const fetchS3Pdp = async <T>(): Promise<T> =>
    await fetchS3(`${PRISMIC_S3_ENDPOINT}/cache/pdp__${lowerCaseLocale()}.json`)

export const fetchS3PdpSizes = async <T>(): Promise<T> =>
    await fetchS3(`${PRISMIC_S3_ENDPOINT}/cache/pdp_sizes__${lowerCaseLocale()}.json`)

export const fetchS3Brands = async <T>(): Promise<T> =>
    await fetchS3(`${PRISMIC_S3_ENDPOINT}/cache/brands__${lowerCaseLocale()}.json`)

export const fetchS3BreadcrumbSpecialCategory = async <T>(): Promise<T> =>
    await fetchS3(`${PRISMIC_S3_ENDPOINT}/cache/breadcrumb_special_category__${lowerCaseLocale()}.json`)
